import * as React from 'react';
import { TextColor, TextStyle, TextAlignment } from '@doordash/design-language';
import ListCell, { ListCellInsetSize, ListCellIconType } from '@doordash/component-list-cell';
import { MenuItemTitleWrapper } from './styles.js';
import { MenuSize, MenuSelectPosition } from './types.js';
import { MenuSelectTypeIcon } from './constants.js';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MenuItem = function MenuItem(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? MenuSize.Medium : _ref$size,
      props = _objectWithoutProperties(_ref, ["size"]);

  var customTitleOverrides = props.listCellProps ? props.listCellProps.titleOverrides : undefined;
  return /*#__PURE__*/React.createElement(ListCell, _extends({
    insetSize: ListCellInsetSize.Small,
    isSquished: true,
    columnGapSize: 6,
    iconStart: props.selectType && props.selectPosition !== MenuSelectPosition.Trailing ? {
      isInteractive: false,
      type: ListCellIconType[props.isSelected ? MenuSelectTypeIcon[props.selectType].selected : MenuSelectTypeIcon[props.selectType].unselected],
      color: props.isSelected ? 'ToggleBorderOn' : 'ToggleBorderOff'
    } : undefined,
    iconEnd: props.selectType && props.selectPosition === MenuSelectPosition.Trailing ? {
      isInteractive: false,
      type: ListCellIconType[props.isSelected ? MenuSelectTypeIcon[props.selectType].selected : MenuSelectTypeIcon[props.selectType].unselected],
      color: props.isSelected ? 'ToggleBorderOn' : 'ToggleBorderOff'
    } : undefined,
    onClick: props.onClick
  }, props.listCellProps, {
    title: props.title && /*#__PURE__*/React.createElement(MenuItemTitleWrapper, null, props.title),
    titleOverrides: props.title ? _objectSpread({
      color: TextColor.MenuItemForeground,
      styles: TextStyle["Menu".concat(size, "Body")],
      textAlign: props.titleAlign && TextAlignment[props.titleAlign]
    }, customTitleOverrides) : undefined,
    isSeparatorVisible: false
  }));
};

export { MenuItem as default };
